<template>
  <div class="app-email-w forse-show-content">
    <nav class="navbar navbar-expand-lg navbar-light">

      <div class="element-box" style="background-color: #ffffff;">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <h4>Listado de Posiciones</h4>
        </div>
        <div class="form-inline" style="text-align: right;">
          <input class="form-control mr-sm-3" type="text" v-model="barra_especifica"
            placeholder="Barra de Posición Específica">
          <button class="btn btn-md btn-outline-dark" @click="imprimir_barra()">
            <i class="fas fa-print"></i>
          </button>
        </div>
      </div>

    </nav>
    <div class="app-email-i">
      <div class="ae-list-w" style="background-color: #e8f6e0;">
        <div class="ae-list ps ps--theme_default ps--active-y" style="height: auto;">
          <div class="element-box" style="background-color: #e8f6e0;">
            <div class="collapse navbar-collapse">
              <h6>Tienda / Bodega</h6>
              <select class="form-control" autofocus="autofocus" v-model="current.tienda" @change="refreshBodega">
                <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">{{ tienda.codigo }} - {{
                  tienda.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="ae-item with-status status-black" onClick="window.location.reload();">
            <div class="aei-image">
            </div>
            <div class="aei-content">
              <h5 class="aei-title">
                Posición
                <i class="fas fa-boxes"></i>
              </h5>
              <div class="aei-sub-title">
                Posiciones Generales de Producto
              </div>
              <div class="aei-text">
                Actualmente Existen:
              </div>
            </div>
          </div>
          <div class="ae-item with-status status-green" onClick="window.location.reload();">
            <div class="aei-image">
            </div>
            <div class="aei-content">
              <h5 class="aei-title">
                Carrito
                <i class="fas fa-dolly"></i>
              </h5>
              <div class="aei-sub-title">
                Posición Tipo Carrito
              </div>
              <div class="aei-text">
                Actualmente Existen:
              </div>
            </div>
          </div>
          <div class="ae-item with-status status-green" onClick="window.location.reload();">
            <div class="aei-image">
            </div>
            <div class="aei-content">
              <h5 class="aei-title">
                Estación
                <i class="fas fa-pallet"></i>
              </h5>
              <div class="aei-sub-title">
                Posición tipo Estación
              </div>
              <div class="aei-text">
                Actualmente Existen:
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ae-content-w">
        <div class="">
          <div class="aec-full-message-w">
            <div class="aec-full-message">
              <div class="message-head">
                <div class="user-w with-status status-green">
                  <div class="user-avatar-w">
                    <div class="user-avatar">
                      <img alt="" src="img/avatar1.jpg" />
                    </div>
                  </div>
                  <div class="user-name">
                    <h5>
                      Posiciones de Bodega 172
                    </h5>
                    <div class="user-role">
                      Tipo Carrito <span>/ 20 resultados </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="message-content">
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nombre</th>
                        <th style="text-align: right;">Código de Barra</th>
                        <th style="text-align: right;">Imprimir</th>
                      </tr>
                    </thead>
                  </table>
                  <div style="text-align: right;">
                    <button class="btn btn-sm btn-dark disabled">
                      <i class="fas fa-print"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      barra_especifica: "",
      tiendas: [],
      bodegas: [],
      current: {
        tienda: '',
      },
    };
  },
  mounted() {
    this.refreshBodega();
    this.refreshTiendas();
  },
  methods: {
    refreshTiendas() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tiendas = res.data;
      });
    },
    refreshBodega() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "productos", params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() { },
    imprimir_barra() {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=wms/barra_posicion_x_bar.jrxml&codigo_barra=${this.barra_especifica}`
      );
    },
  },
};
</script>
